import { FC } from "react";
import { Stack, Box } from "@mui/material";
import { InfoDetailContainer } from "../../activationPortalSections.styled";
import { IActivationPortalInitialValues } from "app/data/types";
import { useAppSelector } from "hooks";
import { selectActivationPaymentState } from "app/data/selectors/activationPortalSelectors";
import { findPaymentMethod } from "app/data/helpers/activationPaymentHelpers";

const PaymentDetailsOverview: FC<
  IActivationPortalInitialValues & { translator: any }
> = ({ initialValues, order = 3, translator }) => {
  const { methodsCatalog } = useAppSelector(selectActivationPaymentState);

  // Present only once the feature is on and a method was actually chosen; the
  // legacy flow has neither.
  const selectedMethod = findPaymentMethod(
    methodsCatalog,
    initialValues.paymentMethod || ""
  );

  // A method that does not use a bank account should not display an empty one.
  const showBankAccount = selectedMethod ? selectedMethod.requiresIban : true;

  return (
    <Stack spacing={3}>
      <h5>
        {order}.{" "}
        {translator("titles.paymentDetails", {
          ns: "activationPortal"
        })}
      </h5>
      <Box>
        <InfoDetailContainer>
          <h6>
            {translator("accountHolderName.label", {
              ns: "formFieldsTranslation"
            })}
          </h6>
          <p>{initialValues.accountHolderName || ""}</p>
        </InfoDetailContainer>

        {showBankAccount && (
          <InfoDetailContainer>
            <h6>
              {translator("bankAccountNumber.label", {
                ns: "formFieldsTranslation"
              })}
            </h6>
            <p>{initialValues.bankAccountNumber || ""}</p>
          </InfoDetailContainer>
        )}

        {selectedMethod && (
          <InfoDetailContainer>
            <h6>
              {translator("titles.paymentMethod", { ns: "activationPortal" })}
            </h6>
            <p>{selectedMethod.displayName}</p>
          </InfoDetailContainer>
        )}
      </Box>
    </Stack>
  );
};

export default PaymentDetailsOverview;
